<template>
  <v-container fill-height align-center>
    <v-row class="pa-8" justify="center">
      <v-col cols="12" md="8">
        <v-row align="center" justify="center">
          <div :class="`text-center ${ $vuetify.breakpoint.xs ? 'headline mb-5 ' : $vuetify.breakpoint.smAndUp ? 'display-2 mb-4 px-5 ' : 'display-2 mb-3 px-5 ' }`">
            {{ $language.registration["Click here to watch a short introductory video"] }}

          </div>

          <div key="not-playing" class="my-4 px-3" v-show="!youtube">

            <div class="text-xs-center">
              <v-icon color="primary" :style="`font-size: ${ $vuetify.breakpoint.xs ? 128 : $vuetify.breakpoint.sm ? 196 : 196 }px`" @click="youtube = true">far fa-play-circle</v-icon>
            </div>
          </div>
          <div v-show="youtube" key="playing">
            <youtube style="width: 100%; max-width: 960px; height: 500px;" :video-id="'bKjb3uu2bqY'" ref="youtube" :player-vars="playerVars" resize></youtube>
          </div>
        </v-row>
      </v-col>

      <v-col cols="12" md="8">
        <v-row align="center" justify="center">
          <v-btn block style="height: 60px;" color="primary" class="px-0 mx-0 mt-4" @click="$emit('completeRegistration')">
            {{ $language.registration["Complete registration"] }}
          </v-btn>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
  <!-- <v-layout column fill-height align-space-around justify-center >
  <v-layout column fill-height justify-center align-space-around>
    <div key="not-playing" class="my-4 px-3" v-show="!youtube">
      <div  :class="`text-xs-center ${ $vuetify.breakpoint.xs ? 'headline mb-5' : $vuetify.breakpoint.sm ? 'display-2 mb-4 px-5' : 'display-2 mb-3 px-5' }`">
        {{ $language.registration["Click here to watch a short introductory video"] }}
      </div>
      <div class="text-xs-center">
        <v-icon color="primary" :style="`font-size: ${ $vuetify.breakpoint.xs ? 128 : $vuetify.breakpoint.sm ? 196 : 196 }px`" @click="youtube = true">far fa-play-circle</v-icon>
      </div>
    </div>
    <div v-show="youtube" key="playing">
      <youtube style="width: 100%; max-width: 960px; height: 500px;" :video-id="'bKjb3uu2bqY'" ref="youtube" :player-vars="playerVars" resize></youtube>
    </div>
    <v-flex px-3 :style="`min-height: 80px; max-height: 80px; ${ $vuetify.breakpoint.mdAndUp ? 'max-width: 960px; margin-left: calc(50% - 480px)' : '' }`">
      <v-btn block style="height: 60px;" color="primary" class="px-0 mx-0 mt-4" @click="$emit('completeRegistration')">
        {{ $language.registration["Complete registration"] }}
      </v-btn>
    </v-flex>
  </v-layout>

  <v-dialog v-model="youtube" class="transparent" width="calc(100vw * 0.85)" max-width="calc(100vw * 0.85)">
    <v-layout fill-height align-center justify-center>
      <div>
        <youtube style="width: calc(100vw * 0.85); max-width: 960px" :video-id="'BBJa32lCaaY'" ref="youtube" resize></youtube>
      </div>
    </v-layout>
  </v-dialog>
</v-layout> -->
</template>

<script>
import {
  mapState
} from 'vuex'
export default {
  data () {
    return {
      videoBackground: {
        'background-color': 'white',
        // 'background-image': `url(${ require('@/assets/hefe-test.jpg') })`,
        'background-image': `linear-gradient(to bottom, rgba(0,0,0,0.50) 0%,rgba(0,0,0,0.50) 100%), url(${require('@/assets/topography.svg')})`,
        'background-position': 'center center',
        'background-repeat': 'repeat scroll',
        'background-size': 'cover'
      },
      youtube: false,
      playerVars: {
        autoplay: 1
      }
    }
  },
  watch: {
    youtube: function (yt) {
      if (yt) {
        this.playVideo()
      } else {
        this.pauseVideo()
      }
    }
  },
  computed: {
    ...mapState(['userProfile', 'currentUser', 'categories'])
  },
  methods: {
    openFullscreen (el) {
      if (el.requestFullscreen) {
        el.requestFullscreen()
      } else if (el.mozRequestFullScreen) { /* Firefox */
        el.mozRequestFullScreen()
      } else if (el.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
        el.webkitRequestFullscreen()
      } else if (el.msRequestFullscreen) { /* IE/Edge */
        el.msRequestFullscreen()
      }
    },

    playVideo () {
      this.$nextTick(() => {
        this.$refs.youtube.player.playVideo()
      })
    },
    pauseVideo () {
      this.$nextTick(() => {
        this.$refs.youtube.player.pauseVideo()
      })
    }
  }
}
</script>
